import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useRouting } from '../../shared/use-routing';
import styles from './CustomLink.css';

const cx = classnames.bind(styles);

function CustomLink(props) {
    const { className, onClick, to, target, children, replace, withDefaultClassName, style, ariaLabel } = props;
    const { location } = useRouting();
    const classes = cx({
        link: withDefaultClassName,
        [className]: Boolean(className)
    });
    const handleClick = e => {
        if (location.pathname === to) {
            e.preventDefault();
        }

        onClick?.(e);
    };

    if (target === '_blank') {
        return (
            <a
                className={classes}
                onClick={handleClick}
                href={to}
                target='_blank'
                rel='noopener noreferrer'
                style={style}
                aria-label={ariaLabel}
            >
                {children}
            </a>
        );
    }

    if (target === 'custom') {
        return (
            <a
                className={classes}
                onClick={handleClick}
                href={to}
                rel='noopener noreferrer'
                style={style}
                aria-label={ariaLabel}
            >
                {children}
            </a>
        );
    }

    return (
        <Link
            className={classes}
            onClick={handleClick}
            to={to}
            replace={replace}
            style={style}
            aria-label={ariaLabel}
        >
            {children}
        </Link>
    );
}

CustomLink.defaultProps = {
    onClick: null,
    className: '',
    target: '',
    replace: false,
    withDefaultClassName: true,
    style: {}
};

CustomLink.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    target: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    replace: PropTypes.bool,
    withDefaultClassName: PropTypes.bool,
    style: PropTypes.object,
    ariaLabel: PropTypes.string
};

export default CustomLink;
